// src/components/filter.
import React from "react"
//import components
import Breadcrumbs from "../../components/Common/Breadcrumb"
import TableContent from "./TableContent"


const BulkRequest: React.FC = () => {

  //meta title
  document.title = "Bulk Request | Zulu Courier"

  return (
    <div className="page-content">
      <div className="container-fluid">
        <Breadcrumbs title="Bulk Request" breadcrumbItem="Create Bulk Request" />
        <TableContent />
      </div>
    </div>
  )
}

export default BulkRequest
